import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles, ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary } from '@material-ui/core';
import { ExpandMore as ExpandMoreIcon } from '@material-ui/icons';
import { ApplianceIconComponent } from 'data/common/iconsvg';
import ProductModuleDetail from './ProductModuleDetail';

class DetailExpansionPanelRow extends PureComponent {
    static propTypes = {
        theme: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired,
        line: PropTypes.object.isRequired,
        moduleKey: PropTypes.string.isRequired,
        expanded: PropTypes.string,
        handleChange: PropTypes.func.isRequired,
        lineType: PropTypes.string.isRequired,
        lineLabel: PropTypes.string.isRequired
    };
    static defaultProps = {
        expanded: null
    };

    render() {
        const { classes, theme, moduleKey, expanded, handleChange, lineType, lineLabel, line } = this.props;
        return (
            <ExpansionPanel key={moduleKey} expanded={expanded === moduleKey}>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    onClick={handleChange}
                    className={classes.panelSummary}
                    classes={{ content: classes.panelSummaryContent }}
                >
                    <ApplianceIconComponent productType="fhe_product" productLineType={lineType} color={theme.palette.primary.main} size={30} />
                    <span className={classes.accordionTitle}>{lineLabel}</span>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <ProductModuleDetail expanded={expanded} lineType={lineType} line={line} className={classes.details} />
                </ExpansionPanelDetails>
            </ExpansionPanel>
        );
    }
}

const styles = theme => ({
    panelSummary: {
        padding: '4px 12px'
    },
    panelSummaryContent: {
        alignItems: 'center'
    },
    accordionTitle: {
        paddingLeft: 10,
        color: theme.palette.common.black
    },
    details: {
        width: '100%'
    }
});

export default withStyles(styles, { withTheme: true })(DetailExpansionPanelRow);



// WEBPACK FOOTER //
// ./environments/fhepool/scenes/SDM17DEC/ProductModule/DetailExpansionPanelRow.js